import { z } from 'zod';

export const companyPartyValues = ['supplier', 'processor', 'platform'] as const;
export type CompanyPartyType = (typeof companyPartyValues)[number];

export const companySchema = z.object({
  company_id: z.string(),
  legal_name: z.string(),
  display_name: z.string(),
  company_role: z.string(),
  party_type: z.enum(companyPartyValues),
  registration_info: z.string().nullable().optional(),
  short_code: z.string().nullable().optional(),
  active_flag: z.boolean(),
  created_at: z.string(),
  updated_at: z.string(),
});

export type Company = z.infer<typeof companySchema>;

export const companyFormSchema = z.object({
  legal_name: z.string().min(1, '会社名を入力してください'),
  display_name: z.string().min(1, '表示名を入力してください'),
  party_type: z.enum(companyPartyValues),
  registration_info: z.string().optional(),
  short_code: z.string().max(8, '8文字以内で入力してください').optional(),
  active_flag: z.boolean().optional(),
});

export type CompanyFormInput = z.infer<typeof companyFormSchema>;

export interface CompanyCreateInput {
  legal_name: string;
  display_name: string;
  party_type: CompanyPartyType;
  registration_info?: string;
  short_code?: string;
}

export interface CompanyUpdateInput {
  legal_name?: string;
  display_name?: string;
  registration_info?: string;
  short_code?: string;
  active_flag?: boolean;
}
